import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Password } from "primereact/password";

export default function UserForm({ isOpen, onClose, onSubmit, initialData }) {
  const [formData, setFormData] = useState({
    userId: 0,
    currentId: 0,
    address: "",
    notes: "",
    gender: 0,
    fullName: "",
    email: "",
    mobilePhones: "",
    status: true,
    password: "",
    birthDate: new Date().toISOString(),
    recordDate: new Date().toISOString(),
    updateContactDate: new Date().toISOString(),
  });

  useEffect(() => {
    setErrors({});
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({
        userId: 0,
        currentId: 0,
        address: "",
        notes: "",
        gender: 0,
        fullName: "",
        email: "",
        mobilePhones: "",
        status: true,
        password: "",
        birthDate: new Date().toISOString(),
        recordDate: new Date().toISOString(),
        updateContactDate: new Date().toISOString(),
      });
    }
  }, [initialData]);
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName.trim()) {
      newErrors.fullName = "Boş bırakılamaz.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Boş bırakılamaz.";
    }
    if(!initialData){    if (!formData.password) {
      newErrors.password = "Boş bırakılamaz.";
    }
}

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Hata yoksa true döner
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors({ ...errors, [name]: null });
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };
  const generateRandomPassword = (length = 12) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  };

  const handleGeneratePassword = (e) => {
    e.preventDefault();
    const newPassword = generateRandomPassword();
    setFormData({ ...formData, password: newPassword });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
    }
  }; 
  const footer = () => {
    return (
      <div className=" flex  w-full m-0">
        <div className="p-d-flex p-jc-end col-12 ">
         <Button
                   className="w-full "
                   label={initialData ? "Güncelle" : "Kaydet"}
                   icon= "pi pi-check"
                   severity={initialData ? "info" : "success"}
                   outlined
                   onClick={handleSubmit}
                 />
        </div>
      </div>
    );
  };
  return (
    <Dialog
      className="max-w-full w-11 md:w-11  xl:w-8  "
      visible={isOpen}
      footer={footer()}
      onHide={onClose}
      header={initialData ? "Kullanıcı Görüntüle" : "Yeni Kullanıcı"}
    >
      <form className="  grid mt-3  ">
        <div className="col-12 md:col-6 ">
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Ad Soyad</span>
            <InputText 
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
            />
            {errors.fullName && (
              <span className="p-inputgroup-addon max-w-max">
                <small className="p-error">{errors.fullName}</small>
              </span>
            )}
          </div>
        </div>
        <div className="col-12 md:col-6 ">
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Email</span>
            <InputText
              id="email" 
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && (
              <span className="p-inputgroup-addon max-w-max">
                <small className="p-error">{errors.email}</small>
              </span>
            )}
          </div>
        </div>
        <div
          className={`col-12 md:col-6  ${
            initialData && "hidden"
          } `}
        >
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Şifre</span>
            <Password
              id="password"
              name="password"
              placeholder="Mevcut şifre görüntülemez"
              value={formData.password}
              onChange={handleChange}
              weakLabel="Kolay"
              mediumLabel="Orta"
              strongLabel="Zor"
              toggleMask
              promptLabel="Güçlü şifrenizi giriniz."
              inputStyle={{
                width: "100%",
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
              }} 
              pt={{ iconField: { root: { className: "w-full" } } }}
            />
            <Button
              label="Üret"
              icon="pi pi-refresh"
              onClick={handleGeneratePassword}
              severity="info"
            />
            {errors.password && (
              <span className="p-inputgroup-addon max-w-max">
                <small className="p-error">{errors.password}</small>
              </span>
            )}
          </div>
        </div>
        <div className="col-12 md:col-6 ">
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Adres</span>
            <InputText
              id="address"
              name="address" 
              value={formData.address}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="col-12 md:col-6 ">
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Telefon</span>
            <InputText
              id="mobilePhones"
              name="mobilePhones" 
              value={formData.mobilePhones}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="col-12 md:col-6 ">
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Not</span>
            <InputText
              id="notes"
              name="notes" 
              value={formData.notes}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="col-12 md:col-6 ">
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Cinsiyet</span>
            <Dropdown
              id="gender"
              name="gender" 
              value={formData.gender}
              options={[
                { label: "Erkek", value: 0 },
                { label: "Kadın", value: 1 },
              ]}
              onChange={(e) => handleDropdownChange("gender", e.value)}
            />
          </div>
        </div>
        <div
          className={`col-12 md:col-6   ${
            initialData && "hidden"
          }`}
        >
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem ">Durum</span>
            <Dropdown
              id="status"
              disabled={initialData}
              name="status"
              value={formData.status}
              options={[
                { label: "Aktif", value: true },
                { label: "Pasif", value: false },
              ]}
              onChange={(e) => handleDropdownChange("status", e.value)}
            />
          </div>
        </div>
      </form>
    </Dialog>
  );
}
